import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AutoSEOProvider } from './components/SEO/AutoSEOProvider'

// Your existing components
import HomePage from './pages/Index'
import AboutPage from './pages/About'
import ServicesPage from './pages/Services'
import BlogPage from './pages/Blog'
import BlogPost from './pages/BlogPost'
import PortfolioPage from './pages/Portfolio'
import CareersPage from './pages/Careers'
import ContactPage from './pages/Contact'

function App() {
  return (
    <HelmetProvider>
      {/* 🚀 WRAP YOUR ENTIRE APP - SEO IS NOW AUTOMATED */}
      <AutoSEOProvider
        siteName="FortifyTek"
        defaultTitle="FortifyTek - AI Solutions & Enterprise Technology Services"
        defaultDescription="Transform your business with AI solutions, NetSuite development, Shopify Plus services, and enterprise technology consulting from FortifyTek."
        defaultImage="/images/og-default.jpg"
        business={{
          name: "FortifyTek",
          phone: "+1-555-FORTIFY",
          address: "123 Tech Street",
          city: "San Francisco",
          state: "CA"
        }}
        autoFix={true}
        trackAnalytics={true}
      >
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:service" element={<ServicesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Router>
      </AutoSEOProvider>
    </HelmetProvider>
  )
}

export default App